import React, { useCallback, useState } from 'react';
import {
  evaluationCheckListItems,
  insightsItems,
} from './evaluationCheckListUtilities';

export default function AgentInsightTab({ data, translate }) {
  const performanceData = evaluationCheckListItems(data);
  const insights = insightsItems(data);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = useCallback((index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  }, []);

  const InsightCard = React.memo(function InsightCard({
    item,
    index,
    isExpanded,
    toggleExpand,
    translate,
  }) {
    const MAX_LENGTH = 200;
    const text = item.text ?? '-_-';
    const isLong = text.length > MAX_LENGTH;

    const displayedText =
      isLong && !isExpanded ? `${text.slice(0, MAX_LENGTH)}...` : text;

    return (
      <div className='insight-card'>
        <div className='insight-title'>
          <span className='emoji'>{item.emoji}</span>
          <span className='insight-title'>{translate(item.title)}</span>
        </div>
        <div className='insight-text'>
          <p>{displayedText}</p>
          {isLong && (
            <button
              onClick={() => toggleExpand(index)}
              className='show-more-btn'
            >
              {isExpanded ? translate('Show Less') : translate('Show More')}
            </button>
          )}
        </div>
      </div>
    );
  });

  return (
    <>
      <div className='agent-performance-table'>
        <h3>Agent Performance Breakdown</h3>
        <table className='performance-table'>
          <thead>
            <tr>
              <th>{translate('criteria')}</th>
              <th>{translate('achieved-value')}</th>
              <th>{translate('base-value')}</th>
            </tr>
          </thead>
          <tbody>
            {performanceData.map((item, index) => (
              <tr key={index}>
                <td>{translate(item.criteria)}</td>
                <td>{item.achieved}</td>
                <td>{item.base}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='insights-grid'>
        {insights.map((item, index) => (
          <InsightCard
            key={index}
            item={item}
            index={index}
            isExpanded={expandedItems[index] || false}
            toggleExpand={toggleExpand}
            translate={translate}
          />
        ))}
      </div>
      {data.agentEvaluations?.[0]?.isRisk && (
        <div className='alert-danger-wrapper mx-3'>
          ⚠️ Risk Detected: {data.agentEvaluations?.[0]?.riskReason}
        </div>
      )}
    </>
  );
}
